<div style="padding: 10px">

  @if (service && loaded) {
    <merkator-mapprint-client
      [boxCenter]="boxCenter"
      [service]="service"
      [mapinfo]="mapinfo"
      [presets]="presets"
      (boxEvent)="boxevent($event)"
      (printEvent)="alert($event)"
      (saveEvent)="alert($event)"
      [canvas]="mapService.canvas"
      (canvasEvent)="canvasEvent($event)">
    </merkator-mapprint-client>
  }
  <!-- <merkator-mapprint *ngIf="service && loaded"
  [boxCenter]="boxCenter"
  [service]="service"
  [mapinfo]="mapinfo"
  [presets]="presets"
  (boxEvent)="boxevent($event)"
  (printEvent)="alert($event)"
  (saveEvent)="alert($event)"
  [canvas]="mapService.canvas"
  (canvasEvent)="canvasEvent($event)">
</merkator-mapprint> -->
@if (featuresInsideBbox && objectKeys(featuresInsideBbox).length > 0) {
  <mat-card class="featuresCardContainer">
    <mat-accordion #featuresAccordion class="bevindingenAccordion" displayMode="flat">
      @for (layer_name of objectKeys(featuresInsideBbox); track layer_name) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-description>
              {{layer_name}} <mat-checkbox style="position:absolute; right: 49px;" checked="true" (change)="toggleAllFeatures(layer_name, $event)"></mat-checkbox>
            </mat-panel-description>
          </mat-expansion-panel-header>
          @for (feature of featuresInsideBbox[layer_name]; track feature) {
            <mat-card (mouseenter)="highlightFeature(feature);" (mouseleave)="stopHighlightFeature(feature);"  class="featuresCard">
              <div class="row space-between-center">
                <p class="featureText">{{feature.getProperties().feature_identifier_name}}</p>
                <mat-checkbox style="margin: 5px 5px 0px 5px" checked="true" id="{{makeFeatureCheckBoxId(feature, layer_name)}}" (change)="toggleFeature(layer_name, feature, $event)"></mat-checkbox>
              </div>
            </mat-card>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-card>
}
</div>

